"use client"

import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { CancelButton } from "@src/components/Button"
import Icons from "@src/components/Icons"
import { styled } from "@mui/material/styles"
import { useTranslation } from "react-i18next"

const TableContainer = styled("table")({
  border: "1.5px solid #7D7D7D",
  borderCollapse: "collapse",
  "& td, th": {
    padding: "16px",
    border: "1.5px solid #7D7D7D",
    "@media (max-width: 600px)": {
      padding: "4px"
    }
  }
})

const TableHead = styled("tr")({
  backgroundColor: "#434343",
  color: "white",
  textAlign: "center",
  fontSize: {
    xs: "12px",
    md: "16px"
  },
  fontWeight: "600",
  lineHeight: "24px",
  textTransform: "uppercase"
})

const Title = styled(Typography)({
  fontSize: {
    xs: "10px",
    md: "14px"
  },
  fontWeight: "600",
  whiteSpace: {
    xs: "wrap",
    lg: "nowrap"
  },
  display: "flex",
  justifyContent: "center"
})

const ListItem = styled(Typography)({
  fontSize: {
    xs: "10px",
    md: "14px"
  },
  lineHeight: "24px",
  display: "list-item",
  marginLeft: "20px"
})

const ChangeItem = ({ onClose }) => {
  const { t } = useTranslation("home-policy")
  const hotline = t("support.hotline_number")

  return (
    <Box position="relative">
      <TableContainer>
        <tbody>
          <TableHead>
            <td></td>
            <td>{t("return.online")}</td>
            <td>{t("return.offline")}</td>
          </TableHead>
          <tr>
            <td rowSpan={2}>
              <Title>{t("return.condition_title")}</Title>
            </td>
            <td colSpan={2}>
              <ListItem>{t("return.condition_1")}</ListItem>
              <ListItem>{t("return.condition_2")}</ListItem>
            </td>
          </tr>
          <tr>
            <td>{t("return.time_online")}</td>
            <td>{t("return.time_offline")}</td>
          </tr>
          <tr>
            <td>
              <Title>{t("return.method_title")}</Title>
            </td>
            <td>{t("return.method_online", { hotline })}</td>
            <td>{t("return.method_offline")}</td>
          </tr>
          <tr>
            <td>
              <Title>{t("return.value_title")}</Title>
            </td>
            <td colSpan={2}>{t("return.value_body")}</td>
          </tr>
          <tr>
            <td>
              <Title>{t("return.policy_title")}</Title>
            </td>
            <td colSpan={2}>
              <ListItem>{t("return.policy_1")}</ListItem>
              <ListItem>{t("return.policy_2")}</ListItem>
              <ListItem>{t("return.policy_3")}</ListItem>
            </td>
          </tr>
          <tr>
            <td>
              <Title>{t("return.fee_title")}</Title>
            </td>
            <td>{t("return.fee_online")}</td>
            <td>{t("return.fee_offline")}</td>
          </tr>
          <tr>
            <td rowSpan={2}>
              <Title>{t("return.note_title")}</Title>
            </td>
            <td colSpan={2}>{t("return.note_1")}</td>
          </tr>
          <tr>
            <td>{t("return.note_2")}</td>
            <td></td>
          </tr>
        </tbody>
      </TableContainer>
      <CancelButton
        type="button"
        height="40px"
        label={t("collapse")}
        endIcon={<Icons name="arrow-up" />}
        minHeight="40px"
        minWidth="160px"
        sx={{
          margin: {
            xs: "24px auto 0",
            md: "48px auto 0"
          }
        }}
        onClick={onClose}
      />
    </Box>
  )
}

export default ChangeItem
